import React from 'react';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import TranslationViewer from '../TranslationViewer';
import {UpdownComponent} from "../Updown/updown";
import './style.css';

const buildGroupedList = (categories) => {
    let list = [];
    for (let i = 0; i < categories.length; i++) {
        list.push(Object.assign({}, categories[i], {
            subCategories: categories[i].subCategories ? categories[i].subCategories.slice() : []
        }));
    }

    for (let i = list.length - 1; i > 0; i--) {
        let c = list[i];
        //find parent for c
        if (!c.parentId) continue;
        let parent = list.find((category) => String(category._id) === String(c.parentId));
        if (!parent) continue;
        if (!parent.subCategories) parent.subCategories = [];
        parent.subCategories.push(c);
    }
    return list;
};

export {buildGroupedList};

export default class CategoryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPath: [],
            menuOpen: false,
            menuListPosition: null,
            menuItemPosition: null,
        };
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleOpenMenu = this.handleOpenMenu.bind(this);
        this.handleCloseMenu = this.handleCloseMenu.bind(this);
    }

    handleItemClick(category) {
        let newPath = this.state.selectedPath.slice();
        if (!!newPath.length) {
            let i = newPath.length - 1;
            while (i >= 0 && newPath[i]._id !== category.parentId) {
                newPath.pop();
                i--;
            }
        }
        newPath.push(category);
        this.setState({selectedPath: newPath});
    }


    handleOpenMenu(listIndex, itemIndex) {
        this.setState({
            menuOpen: !this.state.menuOpen,
            menuListPosition: listIndex,
            menuItemPosition: itemIndex,
        });
    }

    handleCloseMenu(index, selectedItem) {
        this.setState({
            menuOpen: false,
        });
        (index !== null) && (this.props.onMenuSelected) && (this.props.onMenuSelected(index, selectedItem));
    }

    render() {
        let list = buildGroupedList(this.props.list);

        let toBeRendered = [];
        toBeRendered.push(list.filter((cat) => !cat.parentId));
        for (let i = 0; i < this.state.selectedPath.length; i++) {
            let cat = list.find(cat => cat._id === this.state.selectedPath[i]._id);
            if (cat) {
                toBeRendered.push(cat.subCategories);
            }
        }

        return (
            <div className="container-CategoryList">
                {toBeRendered.map((list, listIndex) => {
                    return (list && list.length ?
                            <ul key={listIndex} className="list">
                                {list.sort((item1, item2) => {
                                    return item1.order - item2.order;
                                }).map((item, index) => {
                                    return (
                                        <li key={index}
                                            className={"item " + (listIndex < this.state.selectedPath.length && item._id === this.state.selectedPath[listIndex]._id ? "active" : "")}
                                            onClick={() => {
                                                this.handleItemClick(list[index]);
                                            }}>
                                            <UpdownComponent upDisabled={index === 0}
                                                             downDisabled={index === list.length - 1}
                                                             className={'margin-right-10px'}
                                                             onClick={(isUp) => {
                                                                 this.props.onSwap && this.props.onSwap(
                                                                     list[index]._id, list[index + (isUp ? -1 : 1)]._id
                                                                 );
                                                             }}/>
                                            <div
                                                className="count">{(item.subCategories && item.subCategories.length) || '0'}
                                            </div>
                                            <div className="text">
                                                <TranslationViewer value={item.name}/>
                                            </div>
                                            <Dropdown className="menu-handler"
                                                      isOpen={this.state.menuOpen && this.state.menuListPosition === listIndex && this.state.menuItemPosition === index}
                                                      toggle={() => {
                                                          this.handleOpenMenu(listIndex, index);
                                                      }}>
                                                <DropdownToggle>
                                                    <i className="fas fa-chevron-circle-down"/>
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    {this.props.menu.map((menuItem, ind) =>
                                                        <DropdownItem key={ind} onClick={() => {
                                                            this.handleCloseMenu(ind, toBeRendered[listIndex][index])
                                                        }}>{menuItem.title}</DropdownItem>
                                                    )}
                                                </DropdownMenu>
                                            </Dropdown>
                                        </li>
                                    );
                                })}
                            </ul> : null
                    );
                })
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/03-components/CategoryList/index.js